import React from 'react';
import { AnnouncementBar } from '../components/AnnouncementBar';
import { Nav } from '../components/Nav';
import { Hero } from '../components/Hero';
import { LogoStrip } from '../components/LogoStrip';
import { TaskBriefs } from '../components/TaskBriefs';
import { HowItWorks } from '../components/HowItWorks';
import { Coverage } from '../components/Coverage';
import { Testimonial } from '../components/Testimonial';
import { FinalCta } from '../components/FinalCta';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen w-full bg-canvas text-ink" data-id="element-320" data-mp="24j4u2h1g3y85">
      <AnnouncementBar data-id="element-321" data-mp="29f2byrscxcn1" />
      <Nav data-id="element-322" data-mp="29etvyr0xtr7m" />
      <main data-id="element-323" data-mp="29i7vlri7vmbd">
        <Hero data-id="element-324" data-mp="2dhqkeyd5shjh" />
        <LogoStrip data-id="element-325" data-mp="2di8b7fh1y3k0" />
        <TaskBriefs data-id="element-326" data-mp="2dirtixam6tyk" />
        <HowItWorks data-id="element-327" data-mp="2dj9z4kj62kj5" />
        <Coverage data-id="element-328" data-mp="2dfm7jqxa8872" />
        <Testimonial data-id="element-329" data-mp="3kvk6gmce9571" />
        <FinalCta data-id="element-330" data-mp="3kw1xn4k78t83" />
      </main>
      <Footer data-id="element-331" data-mp="3kuqtv4qr7lgz" />
    </div>;
}